




























































import Component from 'vue-class-component';

import { BaseVue } from '@/BaseVue';
import UiCard from '@/components/ui/UiCard.vue';

@Component({
  components: { UiCard },
})
export default class Announcements extends BaseVue {
  showAnnouncements = false;
  expandedAnnouncement = -1;
  page = 1;
  pageSize = 4;

  readonly announcements = [
    {
      date: 'Aug 21',
      title: `LIVE TRAINING: Learn how to use Bitwave Agentic`,
      content: `
      Last month, we launched Bitwave Agentic, our new suite of tools and features to extend Bitwave access to the AI agents your team is already using. Now, we want to show you how to put it to work.
      <br><br>
      On August 26th, we're hosting a live training webinar covering where to find Bitwave's new agentic features, how they work, and how your team can begin incorporating them into your everyday workflows.
      <br><br>
      <b>What:</b> Bitwave Agentic Live Training Webinar
      <br>
      <b>When:</b> Wednesday, August 26th
      <br>
      <b>Time:</b> 11:30am PT/2:30pm ET
      <br><br>
      Can't attend live? We've got you. Register anyway, and we'll send you the recording.
      <br><br>
      See you there!
      <br><br>
      <a href="https://bitwave-io.zoom.us/webinar/register/7117873306816/WN_dfLUNEI2Rj2yfNViBWCZoQ" target="_blank" class="tw-ml-auto tw-underline tw-text-primary-400">Register for this Live Training on Zoom</a>
      `,
    },
    {
      date: 'Jun 3',
      title: `📣 Register for the Q2 Product Update Webinar!`,
      content: `
      We're wrapping up another quarter with a live walkthrough of product updates across the Bitwave platform, and we'd love to show you what's new.
      <br><br>
      Join us on <b>Tuesday, June 9th, at 10am PST/1pm EST</b> for our Q2 Product Update Event, exclusively for customers and partners.
      <br><br>
      We'll demo recently released functionality, preview upcoming features, and share what's next on the Bitwave roadmap.
      <br><br>
      Some of what you'll get to see:
      <br>
      &emsp;● Sandbox environments for testing and validation
      <br>
      &emsp;● Improved Actions Report Processing
      <br>
      &emsp;● Payment approval workflows
      <br>
      &emsp;● Improvements to advanced enterprise security module
      <br>
      &emsp;● Advanced transaction labeling and automation
      <br>
      &emsp;● Billing visibility improvements
      <br>
      &emsp;● ...and more!
      <br><br>
      Save your spot <a href="https://bitwave-io.zoom.us/webinar/register/3217805162904/WN_IH9pzMvEQX2pskJzhTlCLA" target="_blank" class="tw-ml-auto tw-underline tw-text-primary-400">here</a>, and we’ll see you on the webinar!
      `,
    },
    {
      date: 'May 15',
      title: `Important Update to Single Sign-On (SSO) in Bitwave`,
      content: `
      We've recently updated how Bitwave detects Single Sign-On, or SSO.
      <br><br>
      To improve security, Bitwave now verifies SSO using your organization ID instead of your email address.
      <br><br>
      Going forward, if your administrator has invited you to use SSO, you'll enter your organization ID on the login screen rather than your email address. If you don't know your organization ID, your admin can provide it to you.
      <br><br>
      Once entered, Bitwave will verify whether SSO is enabled for your organization. If verification is successful, you'll see your organization name appear, and you can continue signing in.
      <br><br>
      If SSO cannot be verified for that organization ID, you'll see a message indicating that SSO is not enabled for the organization. If that happens, please contact your administrator or your Bitwave support representative for assistance.
      <br><br>
      Watch <a href="https://www.youtube.com/watch?v=thHsmsGsknE" target="_blank" class="tw-ml-auto tw-underline tw-text-primary-400">this video</a> for a quick walkthrough of what this looks like in Bitwave.
      `,
    },
    {
      date: 'Dec 1',
      title: `Important Update: Upcoming Change to Invoicing`,
      content: `
      Starting Jan 1, 2026, Bitwave will begin collecting sales tax on applicable transactions to comply with regional tax regulations. This change is part of our ongoing commitment to comply with sales tax regulations in jurisdictions where we have tax obligations.
      <br><br>
      If your organization is tax-exempt, please email a valid exemption certificate to <a href="mailto:accounting@bitwave.io" target="_blank" class="tw-ml-auto tw-underline tw-text-primary-400">accounting@bitwave.io</a>
      <br><br>
      International customers please send us your VAT ID for proper tax treatment.
      <br><br>
      Questions? Contact our team anytime!
      `,
    },
    {
      date: 'Nov 14',
      title: `Canton Coin is now listed on major exchanges, and automatic pricing is now live within Bitwave.`,
      content: `We recommend reviewing your existing pricing, rules and potentially discussing with your accounting team what your principal market should be. <br><br> If you have any questions, please contact your Bitwave Solutions team member.
For the time being, the ticker symbol within Bitwave will remain as “CANTON”. <br><br>In the coming weeks, we will transition it to “CC” and will communicate out again when that change will be occurring.`,
    },
    {
      title: `Loving Bitwave? Review us on G2! ⭐`,
      content: `
      If Bitwave has helped simplify your crypto accounting or streamline your operations, we’d love for you to <a href="https://www.g2.com/products/bitwave/review_modalities/new?allow_chat=true" target="_blank" class="tw-ml-auto tw-underline tw-text-primary-400">share your positive experiences on G2</a>. Your review helps us celebrate how far we’ve come, keeps our momentum going, and helps other teams discover what Bitwave can do for them.
      <br><br>
      → <a href="https://www.g2.com/products/bitwave/review_modalities/new?allow_chat=true" target="_blank" class="tw-ml-auto tw-underline tw-text-primary-400">Review Bitwave on G2</a>
      `,
      date: 'Nov 7',
    },
    {
      title: `Discover What’s New in Bitwave Q4 🚀`,
      content: `
      Our biggest release of the year is here! Join us for the Q4 Product Release Webinar for Customers and Partners. We’ll recap the highlights of the EDAS product keynote and take you through new and updated features designed to make digital asset accounting faster, smarter, and more connected than ever.
      <br><br>
      ⏰ Nov 19, 10AM PST/1PM EST
      <br>
      💻 <a href="https://bitwave-io.zoom.us/webinar/register/9817623793674/WN_A5Np2maISwWGHAdb88cFoA" target="_blank" class="tw-ml-auto tw-underline tw-text-primary-400">Register Now</a>
      <br><br>
      Thanks for being part of the Bitwave community. We can’t wait to show you what’s next!
      `,
      date: 'Nov 6',
    },
    {
      title: `Updated QuickBooks Sync Frequency`,
      content: `
      Quickbooks has made an intentional choice to restrict the usability of partner applications like ours, and unfortunately that means we've had to reduce our sync frequency.
      <br><br>
      You can still click sync any time you need updated data.
      <br><br>
      <a href="https://blogs.intuit.com/2025/05/15/introducing-the-intuit-app-partner-program/" target="_blank" class="tw-ml-auto tw-underline tw-text-primary-400">For full details please see their blog post</a>
      `,
      date: 'Aug 8',
    },
    {
      title: `Now Live: Expanded Tracking & Reporting for Solana Validators`,
      content: `
      With our latest feature upgrade, Bitwave delivers an unmatched level of financial transparency and reporting control for validators securing the Solana network.
      <br><br>
      You can now manage millions of Solana transactions, track multiple reward streams, and access audit-ready financial data for reconciliation, reporting, and compliance.
      <br><br>
      Bitwave’s powerful, expanded capabilities enable:
      <br>
      &emsp;● Simplified block, commission, and inflation rewards tracking
      <br>
      &emsp;● Accurate monitoring for hourly rollup voting activity
      <br>
      &emsp;● Audit-ready reporting for tax and accounting compliance
      <br><br>
      This update is available now, but only by request to protect historical data.
      <br><br>
      Ready to unlock our full Solana stacking capabilities? <a href="mailto:solutions@bitwave.io" target="_blank" class="tw-ml-auto tw-underline tw-text-primary-400">Just ask your Bitwave CSO</a>.
      <br><br>
      → <a href="https://www.bitwave.io/blog/solana-validator-support-for-enterprise" target="_blank" class="tw-ml-auto tw-underline tw-text-primary-400">Blog Announcement</a>
      <br>
      → <a href="https://bitwave-dev.atlassian.net/wiki/spaces/Product/pages/993230850/Solana+Enhancements+-+EcoSystem+Building" target="_blank" class="tw-ml-auto tw-underline tw-text-primary-400">Bitwave Documentation</a>
      `,
      date: 'June 30',
    },
    {
      title: `Now Live: Enhanced Subsidiary Support for Global Finance Teams`,
      content: `
      One platform. Every entity. 🌍
      <br><br>
      Bitwave’s expanded subsidiary support gives you complete financial visibility and reporting control across every entity – no matter how complex.
      <br><br>
      Seamlessly manage wallets, currencies, and compliance in a single, unified platform:
      <br><br>
      ✔ ️Map Entities: Define complex relationship structures, like parent-child, sibling, JV, or custodial-client.
      <br>
      ✔ ️Assign Wallets by Entity: Map wallets to specific subsidiaries and enforce access control.
      <br>
      ✔ ️Enable Smart Reporting: Run reports scoped to any defined entity relationship, from individual sub-entities to full roll-ups.
      <br>
      ✔ ️Support Inter-company Accounting: Properly identify and categorize activity between related entities.
      <br>
      ✔ ️Manage Multi-currency Realities: Assign functional currencies to entities and roll reporting up to a base currency.
      <br><br>
      Purpose-built for global operations, this upgrade helps businesses stay compliant, audit-ready, and efficient at scale.
      <br><br>
      → <a href="https://www.bitwave.io/blog/now-live-enhanced-subsidiary-support-for-enterprise-crypto-accounting" target="_blank" class="tw-ml-auto tw-underline tw-text-primary-400">Get the full details</a>
      `,
      date: 'June 17',
    },
    {
      title: `AICPA & Bitwave: Stablecoin Reporting Webinar + 1 CPE Credit`,
      content: `
      Join us for a special conversation with the AICPA as we explore their groundbreaking reporting framework for fiat-backed stablecoins.
      <br><br>
      We’re thrilled to welcome <b>Diana Krupica</b> (AICPA Digital Assets Working Group & Attestation Subgroup member) to break down the new criteria.
      <br><br>
      📆 When: April 29, 12PM ET
      <br>
      🔍 Where: <a href="https://bitwave-io.zoom.us/webinar/register/9017446689820/WN_1emeRrk2StqNUVlhaLjQlA#/registration" target="_blank" class="tw-ml-auto tw-underline tw-text-primary-400">Online Webinar (Register Here)</a>
      <br><br>
      Get expert insights on:
      <br>
      &emsp;1. Key components of the stablecoin reporting criteria
      <br>
      &emsp;2. How to apply this framework in real-world reporting
      <br>
      &emsp;3. What’s next from the AICPA’s digital asset roadmap
      <br><br>
      Don’t miss this exclusive conversation on the future of stablecoin reporting!
      `,
      date: 'Apr 16',
    },
    {
      title: `Customer Notice: Update to Bitwave’s Invoicing System`,
      content: `
      As part of our ongoing commitment to customer satisfaction, we are upgrading our invoicing system.
      <br><br>
      <b>What’s this mean for Bitwave customers?</b>
      <br>
      &emsp;1.&emsp;<i>No action is required</i> – the look and format of your invoice may change, but your subscription details remain the same
      <br>
      &emsp;2.&emsp;New invoices will come from Subscript, instead of Stripe\n or QuickBooks Online
      <br><br>
      This upgrade is part of our continuing efforts to provide you with a smooth and transparent billing experience.
      <br><br>
      If you have any questions, just reach out to your Bitwave support team. 

      `,
      date: 'Apr 14',
    },
    {
      title: `Customer Notice: Update to Bitwave’s Invoicing System`,
      content: `
      As part of our ongoing commitment to customer satisfaction, we are upgrading our invoicing system.
      <br><br>
      <b>What’s this mean for Bitwave customers?</b>
      <br>
      &emsp;● <i>No action is required</i> – the look and format of your invoice may change, but your subscription details remain the same
      &emsp;● New invoices will come from Subscript, instead of Stripe or QuickBooks Online
      <br><br>
      This upgrade is part of our continuing efforts to provide you with a smooth and transparent billing experience.
      <br><br>
      If you have any questions, just reach out to your Bitwave support team. 

      `,
      date: 'Mar 6',
    },
    {
      title: `Introducing: The Bitwave Payment Network! (Sign up for Early Access)`,
      content: `
      You know that legacy payment systems are a mess. They're slow, expensive, and built on outdated infrastructure–costing businesses time and money.
      <br>
      <br>
      There's a better way.
      <br>
      <br>
      The <b>Bitwave Payment Network</b> is a new ecosystem connecting businesses, vendors, and technology partners to power fast, low-cost, and programmable payments on-chain.
      <br>
      <br>
      ✋ <a href="https://bitwavepaymentnetwork-early.carrd.co/" target="_blank" class="tw-ml-auto tw-underline tw-text-primary-400">Sign up for early access to the network</a>
      <br>
      📘 <a href="https://www.bitwave.io/blog/b2b-payments-are-broken-heres-how-blockchain-fixes-them" target="_blank" class="tw-ml-auto tw-underline tw-text-primary-400">Check out our blog for more</a>
      `,
      date: 'Mar 6',
    },
    {
      title: `Coinbase Legacy API Update: Action Needed to Sync Data`,
      content: `
      Coinbase has started expiring legacy API keys, which may disrupt your data sync in Bitwave.
      To keep your Coinbase connection live, you’ll need to create a new API key and update it in Bitwave.
      We’ve made it quick and easy — just follow our step-by-step guide to restore your connection in minutes.
      <br>
      <br>
      👉 <a href="https://www.bitwave.io/blog/coinbase-legacy-api-keys-are-expiring-heres-how-to-stay-connected-in-bitwave" target="_blank" class="tw-ml-auto tw-underline tw-text-primary-400">Get the full details here</a>
      <br>
      <br>
      Need help? Reach us at solutions@bitwave.io.

      `,
      date: 'Feb 19',
    },
    {
      title: `Join Us for “On-Chain B2B Payments Day” at ETHDenver!`,
      content: `
      We’re teaming up with PayPal, Deloitte, and NetSuite to bring you “On-Chain B2B Payments Day” on Feb. 27 at ETHDenver! This full-day event explores how stablecoins are transforming business payments.
      <br>
      <br>
      From a networking brunch and innovative panel session to a casual co-working session and celebratory happy hour, “On-Chain B2B Payments Day” is packed with insights, opportunities, and connection.
      <br>
      <br>
      <a href="https://www.bitwave.io/blog/join-paypal-deloitte-and-bitwave-for-on-chain-b2b-payments-day-ethdenver" target="_blank" class="tw-ml-auto tw-underline tw-text-primary-400">Learn more and secure your spot today.</a>
      <br>
      `,
      date: 'Jan 14',
    },
    {
      title: `Last-Minute IRS Update! New 2025 Guidance for Brokers & Taxpayers`,
      content: `
      Last week, the IRS released an 
      <a href="https://www.irs.gov/pub/irs-drop/n-25-07.pdf" target="_blank" class="tw-ml-auto tw-underline tw-text-primary-400">unexpected update</a>
       expanding on Revenue Procedure 2024-28 — and it caused quite a stir (along with some confusion). 
      The new guidance acknowledges broker limitations with a temporary relief period, while also empowering taxpayers to maintain their own compliance using specific identification or standing order methodologies.
      <br>
      <br>
      <a href="https://www.bitwave.io/blog/last-minute-irs-guidance-and-happy-almost-new-year" target="_blank" class="tw-ml-auto tw-underline tw-text-primary-400">Here’s our full breakdown of the updated guidance.</a>
      <br>
      <br>
      With Bitwave you have total control over your digital asset tracking and reporting, ensuring you can stay compliant — today and tomorrow.
      <br>
      <br>
      Questions? Our team is here to help! Reach out anytime.
      <br>
      `,
      date: 'Jan 7',
    },
    {
      title: `Celebrate Bitwave’s 2024 Milestones – Thanks to You!`,
      content: `
      This was a banner year for Bitwave, and it’s all thanks to you, our incredible customers. 
      <br>
      Our team launched powerful integrations and support for leading ecosystems (like 
      <a href="https://www.bitwave.io/blog/stellar-integration-completes-streamlining-accounting-reporting-for-enterprises" target="_blank" class="tw-ml-auto tw-underline tw-text-primary-400">Stellar</a>, 
      <a href="https://www.bitwave.io/blog/bitwave-and-polymesh" target="_blank" class="tw-ml-auto tw-underline tw-text-primary-400">Polymesh</a>, 
      <a href="https://www.bitwave.io/blog/bitwave-integrates-with-zetachain-simplifying-cross-chain-accounting-ops-regulatory-compliance" target="_blank" class="tw-ml-auto tw-underline tw-text-primary-400">ZetaChain</a>, 
      <a href="https://www.bitwave.io/blog/bitwave-empowers-the-optimism-ecosystem---enabling-scalability-security-compliance" target="_blank" class="tw-ml-auto tw-underline tw-text-primary-400">Optimism</a>, 
      <a href="https://www.bitwave.io/blog/bitwave-accelerates-arbitrum-ecosystem-revolutionizing-ethereums-scalability-and-compliance" target="_blank" class="tw-ml-auto tw-underline tw-text-primary-400">Arbitrum</a>), 
      rolled out game-changing products and updates (<a href="https://www.bitwave.io/blog/the-enterprises-are-here-embracing-the-future-of-b2b-payments" target="_blank" class="tw-ml-auto tw-underline tw-text-primary-400">Enterprise Payments</a>, 
      <a href="https://www.bitwave.io/blog/introducing-data-fusion-by-bitwave" target="_blank" class="tw-ml-auto tw-underline tw-text-primary-400">Data Fusion</a>), and connected at amazing events like 
      <a href="https://www.bitwave.io/blog/missed-edas-earn-free-cpe-catch-up-on-the-action" target="_blank" class="tw-ml-auto tw-underline tw-text-primary-400">EDAS 2024</a>, ETH Denver, Money20/20, Consensus, 
      <a href="https://www.bitwave.io/blog/pop-fizz-balance-how-soda-is-refreshing-crypto-balance-sheet-reporting-mainnet-2024" target="_blank" class="tw-ml-auto tw-underline tw-text-primary-400">Mainnet</a>, and so much more.
      <br>
      We’re honored to lead the charge in digital asset finance innovation – and it wouldn’t be possible without your support.
      <br>
      Catch all the highlights in our Year in Review: <a href="https://www.bitwave.io/blog/bitwave-year-in-review-celebrating-our-2024-milestones" target="_blank" class="tw-ml-auto tw-underline tw-text-primary-400">Read More</a>
      `,
      date: 'Dec 20',
    },
    {
      title: 'November Product Release Notes',
      content: `
      We’re excited to introduce the latest updates, packed with features designed to boost usability, security, and efficiency.
      <br>
      <br>
      ● <b>Accounting Connections:</b>
      <br>
      &emsp;- Metadata Mappers for Payments: Easily map metadata from NetSuite fields directly into payments for better alignment and data consistency.
      <br>
      ● <b>Payments:</b>
      <br>
      &emsp;- Address Verification & Whitelisting: Enhanced security with address verification and whitelisting now on the Bills page.
      <br>
      &emsp;- KYT Checks Toggle: Added flexibility to toggle Know Your Transaction (KYT) checks on or off as needed for payments.
      <br>
      &emsp;- KYT Configuration for Wallets: Added KYT settings for wallet configurations, improving security.
      <br>
      &emsp;- Pricing Default Methods by Asset: Default pricing methods can now be set by asset for simplified payment configurations.
      <br>
      &emsp;- All Supported Currencies Displayed: Payments now display all supported currencies for better visibility.
      <br>
      ● <b>Inventory Views:</b>
      <br>
      &emsp;- Lock Period Feature: Now live, enabling secure lock periods within inventory views for added control.
      <br>
      &emsp;- Custom Controls Added: Enhanced flexibility with features to freeze inventory views and retain prior data, even when new wallets are added.
      <br>
      ● <b>Exchange Connections Enhancements:</b>
      <br>
      &emsp;- Bitfinex: API key validation for new keys, complete with recent transaction and balance snapshots.
      <br>
      &emsp;- Fireblocks: User-friendly key format examples added for a smoother key entry experience.
      <br>
      &emsp;- Bitgo: UTXO chain handling is now supported, with synchronized transactions showing “to” and “from” addresses.
      <br>
      &emsp;- Improved API Key Security: Duplicate API keys are now prevented, ensuring unique and secure connections.
      <br>
      &emsp;- Enhanced UI for Adding Exchanges: Enjoy a sleeker and more intuitive interface when setting up exchange connections.
      <br>
      ● <b>Old Wallet UI Sunsetting:</b>
      <br>
      &emsp;- Upgraded Wallets UI Now Live: The old Wallet UI has been sunset, with all users now on the enhanced Wallets UI. This updated UI offers a sleek design with improved navigation and search functionality.
      <br>
      ● <b>Canton Blockchain:</b>
      <br>
      &emsp;- Balance Support Added: Now supporting balances for the Canton blockchain network, broadening our capabilities.
      <br>
      ● <b>UI Navigation:</b>
      <br>
      &emsp;- New Chrome Experience (Phase 1): The first phase of our upgraded navigation system is live, featuring a sleek arrangement for improved usability.
      <br>
      ● <b>User Experience:</b>
      <br>
      &emsp;- Improved Transaction Validations (Phase 1): The first phase of enhancements to validations and categorizations is now live in the new transactions view.
      <br>
      <br>
      We’re committed to continuous improvements that simplify your experience. Thank you for being a valued part of our journey!
      `,
      date: 'Dec 20',
    },
    {
      title: 'October Product Release Notes',
      content: `
      We’re pleased to announce the latest updates and improvements aimed at enhancing your overall experience and optimizing your workflows.
      <br>
      <br>
      ● <b>Accounting Connections Upgrade:</b>
      <br>
      &emsp;- Introduced a cleaner, more intuitive UI, now accessible through a settings dropdown.
      <br>
      &emsp;- Users can assign or edit connection names upon adding them, with connection names now displayed at the transaction level for easier identification, especially when managing multiple ERP systems.
      <br>
      ● <b>Coinbase Pro Update:</b>
      <br>
      &emsp;- With the deprecation of Coinbase Pro, new connections now display “Exchange” as the only option, simplifying the connection process without ties to the Pro product.
      <br>
      ● <b>UI Reporting Launch:</b>
      <br>
      &emsp;- Launched an enhanced reports center with a modern, streamlined design.
      <br>
      &emsp;- Users can now link directly to specific reports in a single click, improving efficiency in accessing data.
      <br>
      ● <b>Payments Enhancements:</b>
      <br>
      &emsp;- Added a link to the vendor page from the contact view for quicker access.
      <br>
      &emsp;- Users can send whitelist request emails, triggering an approval notification for recipients to take action.
      <br>
      &emsp;- Default payments can now be set for wallets, and auto-reconciliation is enabled for payment transactions.
      <br>
      &emsp;- Enhanced Error Messaging: Improved clarity in error messaging for payments and penny testing.
      <br>
      &emsp;- LINK Token for Penny Testing: Added LINK token support for more comprehensive Penny Test functionality.
      <br>
      &emsp;- Optional Know Your Transaction Check: Flexibility added with optional Know Your Transaction checks for certain payment processes.
      <br>
      ● <b>Bitgo Improvements:</b>
      <br>
      &emsp;- Updated transaction display to include “to” and “from” addresses when available from the custodian.
      <br>
      &emsp;- Implemented upfront API key validation for new connections to ensure accuracy during the setup process.
      <br>
      ● <b>Exchange Connections:</b>
      <br>
      &emsp;- Improved API Key Security: Duplicate API keys are now prevented, ensuring unique and secure connections.
      <br>
      ● <b>Inventory Views:</b>
      <br>
      &emsp;- New Cancel Button: A Cancel button has been added to inventory views for easier management and adjustments.
      <br>
      <br>
      We’re committed to continuous improvements that simplify your experience. Thank you for being a valued part of our journey!
      `,
      date: 'Nov 6',
    },
    {
      title: `You’re Invited! Join Bitwave's Q4 Product Release (Nov 21, Online)`,
      content: `
      Be the first to see Bitwave’s game-changing features, UI updates, and all-new capabilities – engineered to streamline your operations with unmatched digital asset tax, accounting, and compliance efficiency.
      <br>
      <br>
      <b>What:</b> Bitwave Q4 Product Release (Virtual Announcement Event)
      <br>
      <b>When:</b> Nov 21, 3PM ET
      <br>
      <br>
      Catch live demos and major announcements, while unlocking insights directly from Bitwave CEO Pat White. 
      <br>
      <br>
      <a href="https://bitwave-io.zoom.us/webinar/register/WN_i2T5ltOWQW-jp3BLPjUq8Q?" target="_blank" class="tw-ml-auto tw-underline tw-text-primary-400">Secure your spot HERE</a> - you won’t want to miss it!
      `,
      date: 'Oct 30',
    },
    {
      title: 'September Product Release Notes',
      content: `
      We're excited to share several key updates and enhancements designed to improve your experience as well as streamline workflows with more efficient operations.
              <br>
              <br>
              ● <b>Wallets UI Enhancements:</b> Updated visuals on various pages, including the wallets page, now displaying dollar amounts in a clean, formatted view for improved readability.
              <br>
              ● <b>Inline Categorization Updates:</b> Users can now easily copy and paste the "to" and "from" addresses when using inline categorization, simplifying workflows and increasing efficiency.
              <br>
              ● <b>Ethereum Chain Optimization:</b> We've upgraded our Ethereum syncing process, delivering faster performance and more seamless data integration.
              <br>
              ● <b>Anchorage Integration Upgrade:</b> The Anchorage integration has been updated to allow shared hashes on UTXO-based transactions for newly added connections, enhancing transaction flexibility.
              <br>
              ● <b>New Wallet UI Features:</b>
              <br>
              &emsp;- You can now search wallets by name using the newly added search functionality.
              <br>
              &emsp;- Wallet descriptions are now displayed directly on the page once added.
              <br>
              &emsp;- We've introduced validation checks for API keys in several integrations, including Coinbase Prime, Fireblocks, and Foundry, ensuring only valid API keys are accepted.
              <br>
              &emsp;- Metadata fields are now visible within wallet details for better data management.
              <br>
              ● <b>Foundry Enhancements:</b> Sub-account names are now automatically displayed on the connections page, improving clarity for Foundry users.
              <br>
              ● <b>Organizations Page Redesign:</b> The Organizations page has been revamped with a sleeker, more modern interface for a better user experience.
              <br>
              ● <b>SoDA Report Updates:</b> Users with access to the SoDA report can now view wallet roles directly on the wallets page, making it easier to manage roles.
              <br>
              ● <b>Import Template Navigation Improvements:</b> We’ve enhanced import templates with an improved sorting method, offering more intuitive navigation for better usability.
              <br>
              ● <b>Payment Operations Enhancements:</b>
              <br>
              &emsp;- New filtering options allow users to easily sort and manage payments.
              <br>
              &emsp;- Payments are now automatically named with the date and time for easier identification.
              <br>
              &emsp;- Post-creation editing of payment names is now available for greater flexibility.
              <br>
              &emsp;- Full payment addresses are now viewable when opening payment transactions for improved detail visibility.
              <br>
              &emsp;- A loading indicator has been added to the settings page to provide real-time feedback on background processes.
              <br>
              `,
      date: 'Oct 9',
    },
    {
      title: 'NEW: Wallet-Level Cost Basis Tracking Is Here! Unlock Effortless IRS Compliance',
      content: `
              Bitwave is excited to announce an important platform update – starting today, our powerful segregated inventory tracking capability is <a href="https://www.bitwave.io/blog/new-wallet-level-cost-basis-tracking-is-here-unlock-simplified-irs-compliance" target="_blank" class="tw-ml-auto tw-underline tw-text-primary-400">now available to all customers</a> as part of our core service.
              <br>
              <br>
              This update ensures businesses can seamlessly transition to meet the IRS’s new requirement for “account-level” cost basis tracking – by wallet or exchange. Orgs using the “universal wallet” method today can make the switch by creating a new inventory view in Bitwave and checking the “multiple inventories” box.
              <br>
              <br>
              Get all the details in our <a href="https://www.bitwave.io/blog/new-wallet-level-cost-basis-tracking-is-here-unlock-simplified-irs-compliance" target="_blank" class="tw-ml-auto tw-underline tw-text-primary-400">latest blog</a> – and reach out to your Solutions rep with any questions.
              <br>
              <br>
              As regulatory guidance for digital assets evolves, Bitwave remains at the forefront with innovative tools to enable you to operate your business with confidence.
              <br>
              <br>
              <i>(Protip: If you’re not able to access the “multiple inventories” option, try refreshing your account first. Then, check the Advanced Settings to confirm you're using the latest Bitwave engine version.)</i>
              <br>
              <br>
              -The Bitwave Team
              `,
      date: 'Sep 26',
    },
    {
      title: 'Important Update for Coinbase Pro Users',
      content: `
              We’d like to ensure you are prepared for the planned sunset of the Coinbase Pro API service - effective tomorrow.
              <br>
              <br>
              As <a href="https://www.coinbase.com/blog/hello-advanced-trade-goodbye-coinbase-pro" target="_blank" class="tw-ml-auto tw-underline tw-text-primary-400">announced in June 2022</a>, Coinbase Pro will be discontinued, and user activity will be consolidated into other Coinbase products, like Coinbase Advanced.
              <br>
              <br>
              <b>WHAT THIS MEANS</b>
              <br>
              ● If you currently use a legacy Coinbase Pro connection with Bitwave, you will no longer receive new data from this source starting tomorrow.
              <br>
              ● All previous Pro users should confirm that they have been migrated to a new Coinbase service.
              <br>
              <br>
              <b>WHAT ACTIONS ARE NEEDED</b>
              <br>
              ● If you’ve moved to Coinbase Prime, please contact your Bitwave Solutions representative to set up your new API key.
              <br>
              ● This step will ensure uninterrupted data synchronization within Bitwave.
              <br>
              <br>
              <b>OUR COMMITMENT</b>
              <br>
              Bitwave works closely with data source providers – including Coinbase – to help you prepare for important changes. We're dedicated to delivering the highest level of quality for our customers and are able to provide you with this information thanks to our strong industry relationships.
              <br>
              <br>
              With Bitwave, you're always ahead of the curve and ready for what's next. &#127754;
              <br>
              <br>
              Questions? Reach us at <a href="mailto:solutions@bitwave.io" target="_blank" class="tw-ml-auto tw-underline tw-text-primary-400">solutions@bitwave.io</a>.
              <br>
              <br>
              -The Bitwave Team
              `,
      date: 'Sep 10',
    },
    {
      title: 'August Product Release Notes',
      content: `
            We're excited to share several key updates and enhancements designed to improve your experience as well as streamline workflows with more efficient operations.
              <br>
              <br>
              ● <b>Enhanced UI Responsiveness:</b> Improved UI responsiveness for faster loading of tools and balances, specifically for larger organizations.
              <br>
              ● <b>New Accounting Connections Page:</b> Enjoy a sleeker and more consistent look with the newly launched Accounting Connections page, aligning with other recent updates for a cohesive user experience.
              <br>
              ● <b>SoDA Report:</b> New wallet roles have been added, allowing you to search by role name, add or delete roles, and share them with users more efficiently.
              <br>
              ● <b>Foundry API Key Validation:</b> To ensure accuracy, we've implemented validation for API keys, so only correct keys can be entered when adding connections.
              <br>
              ● <b>Sage Top Level ERP Creation Enhancement:</b> The entity-level launch now enables posting individual lines to different entities, enhancing flexibility in ERP management.
              <br>
              ● <b>Metadata Fields Import CSV:</b> Sage customers can now categorize metadata through imports, making it easier to organize and manage your data.
              <br>
              ● <b>Org Navigation Enhancements:</b> You can now open multiple tabs for different organizations, with an alert system in place to warn users logging in with outdated or expired requests.
              <br>
              ● <b>Partner Wallet Manager Integration:</b> Partners can now seamlessly sync blockchain wallets created by clients directly into the organization.
              <br>
              ● <b>Binance Smart Chain Upgrade:</b> We’ve implemented a more efficient syncing method, improving performance and data integration for a smoother user experience.
              <br>
              `,
      date: 'Sep 2',
    },
    {
      title: 'Missed EDAS? Earn Free CPE & Catch Up on the Action',
      content: `
            Couldn't join us in person for last month’s <a href="https://www.bitwave.io/blog/bitwave-current-introducing-bitwave-2-0-data-fusion" target="_blank" class="tw-ml-auto tw-underline tw-text-primary-400">Enterprise Digital Asset Summit (EDAS)</a>? We’ve got you covered.
              <br>
              <br>
              EDAS session recordings are now available for <a href="https://university.bitwave.io/bundles/enterprise-digital-asset-summit-2024" target="_blank" class="tw-ml-auto tw-underline tw-text-primary-400">free, on-demand viewing</a> with up to 6 hours of NASBA-licensed CPE available: 
              <br>
              <br>
              ● The State of Enterprise Adoption for Digital Assets.
              <br>
              ● B2B Enterprise Payments: A Roundtable with Coinbase & Google.
              <br>
              ● Crypto Tax Update with Deloitte: New Treasury Regulations.
              <br>
              ● And 7 more must-watch sessions packed with insights.
              <br>
              <br>
              Sharpen your finance skills, stay ahead of industry trends, and earn those valuable CPE credits today.
              <br>
              <br>
              Sign up for a free <a href="https://university.bitwave.io/bundles/enterprise-digital-asset-summit-2024" target="_blank" class="tw-ml-auto tw-underline tw-text-primary-400">Bitwave University</a> account and dive into our course catalog. It’s that simple!
              `,
      date: 'Aug 21',
    },
    {
      title: 'Introducing Bitwave 2.0: Speed, Efficiency, & Collaboration',
      content: `
            We're excited to announce the launch of Bitwave 2.0 – a complete platform upgrade designed to revolutionize the way you manage digital assets. Re-built from the ground up, Bitwave 2.0 is more than just an upgrade; it's a leap forward in the digital asset finance ecosystem.
              <br>
              <br>
              ● <b>Experience unparalleled speed and scale.</b> Our reimagined data layer can effortlessly handle billions of transactions, delivering lightning-fast reporting and insights.
              <br>
              ● <b>Collaborate seamlessly with your team.</b> Real-time updates and in-line commenting empower your team to work together efficiently, no matter where they are.
              <br>
              ● <b>Gain deeper insights.</b> With enhanced filtering options and bulk syncing, you'll spend less time on data management and more time making informed decisions.
              <br>
              ● <b>Elevate your workflow.</b> Our new user interface is intuitive and packed with features like transaction commenting, change tracking, and file attachments to streamline your processes.
              <br>
              <br>
              Ready to see the future of digital asset finance? <a href="https://www.bitwave.io/blog/introducing-bitwave-2-0-speed-efficiency-collaboration" target="_blank" class="tw-ml-auto tw-underline tw-text-primary-400">Watch the demo now</a> and get ready to experience Bitwave, evolved.
              `,
      date: 'Aug 08',
    },
    {
      title: 'The EDAS 2024 Attendee Guide is Here! (Download PDF)',
      content: `
            Are you joining the on-chain finance and accounting event of the year? (July 24, Nashville)
            <br>
            <br>
            Bitwave’s third annual Enterprise Digital Asset Summit (<a href="http://edas.live" target="_blank" class="tw-ml-auto tw-underline tw-text-primary-400">edas.live</a>) 
            is coming to Nashville next week - and we want to see you there! Check out the 2024 Attendee Guide for agenda info, speakers, FAQ’s, and more. 
            <br>
            <br>
            Don’t have a ticket yet? Contact a Bitwave team member and ask how you can attend powerful panel discussions and insightful headlining sessions – led by world-class speakers 
            from Coinbase, Deloitte, EisnerAmper, Google, Magic Eden, Hedera, KPMG, PwC, and more. 
            <br>
            <br>
            EDAS Attendee Guide (PDF): <a href="https://drive.google.com/file/d/1yTWzH_372RsdjfczMfkcBVxii6qlIxEX/view?usp=sharing" target="_blank" class="tw-ml-auto tw-underline tw-text-primary-400">HERE</a>
            <br>
            <br>
            See you soon in Nashville! 
        `,
      date: 'July 05',
    },
    {
      title: 'Important: USDC Symbol Update in Bitwave (Polygon Network)',
      content: `
      To streamline user workflows, we're updating the way USDC tokens are displayed on Bitwave.
        <br>
        <br>
        What’s Happening? The symbols for Native and Bridged USDC on Polygon are updating:
        <br>
        <br>
            <ul>
                <li>
                    &emsp;1. Native USDC(on Polygon) will use the new symbol: POLY-USDC
                </li>
                <li>
                    &emsp;2. Bridged USDC (on Polygon) will use the new symbol: POLY-USDC.e
                </li>
            </ul>
        <br>
        No action is required for the majority of users. If you are importing these tokens, please ensure you use the correct token identifier.
        For more information, <a href="https://www.bitwave.io/blog/important-usdc-symbol-update-in-bitwave-polygon-network" target="_blank" class="tw-ml-auto tw-underline tw-text-primary-400">please see our full statement</a>.
        `,
      date: 'June 07',
    },
    {
      title: 'Consensus 2024: Meet Bitwave in Texas!',
      content: `
      We're excited to announce Bitwave's participation in Consensus 2024!
        <br>
        <br>
        Join us for a whirlwind week of education, connection, and innovation. Find our team at <b>booth #1318</b>, where you can enter to win a free ticket to #EDAS2024. And, don't miss Co-Founders Pat White and Amy Kalnoki speaking on some must-see panel sessions:
        <br>
        <br>
        ● <b>Crypto Tax Toolkit:</b> Surviving an IRS Exam (feat. Deloitte, Fuel3, and Propeller Industries)
        <br>
        ● <b>Bridging the Gap:</b> Strategies to Prepare Institutions for Crypto Adoption Success (feat. Franklin, Cold.xyz, Mass, & Propeller Industries)
        <br>
        <br>
        Head over to <a href="https://www.bitwave.io/blog/consensus-2024-meet-bitwave-in-texas" target="_blank" class="tw-ml-auto tw-underline tw-text-primary-400">our blog</a> for all the details.
        `,
      date: 'May 24',
    },
    {
      title: 'Inventory View Cost Basis Rollforward now has FMV and Unrealized Gains/Losses',
      content: `
      We've added Fair Market Value and Unrealized gain information into the cost basis rollforward report as heavily requested by many of our partners and customers.
        <br>
        <br>
        To see this please navigate to Left Menu -> Inventory views -> select your inventory view -> reports and head to Cost Basis Rollforward Report.
        <br>
        <br>
        This completes the full valuation reporting picture as you are able to see starting costbasis/carrying value, changes up or down, impairment expense, ending cost basis with the addition of unrealized gains and fair market value.`,
      date: 'Apr 17',
    },
    {
      title: 'ANNOUNCING EDAS 2024 (Nashville, July 24) – Unlocking the Future of On-Chain Finance',
      content: `
      Bitwave’s third annual Enterprise Digital Asset Summit (EDAS) welcomes finance leaders for an exciting, one-day summit to shape the next phase of digital asset innovation and adoption. Register now to join us for powerful panel discussions, insightful headlining sessions, and deep networking opportunities.
        <br>
        <br>
        As a valuable Bitwave customer, you can unlock the LOWEST price possible!
        <br>
        <br>
        Use promo code: <b>BITWAVE100</b>. More info: <a href="https://www.edas.live/" target="_blank" class="tw-ml-auto tw-underline tw-text-primary-400">edas.live</a>.`,
      date: 'Apr 3',
    },
    {
      title: 'Bitwave Current February 2024 Edition is now live!',
      content: `
        Check out our February edition now for product announcements, a deep-dive demo, and tons more to elevate your finance and accounting workflows.
        <br>
        <br>
        Please see our <a href="https://www.bitwave.io/blog/the-bitwave-current-feb-2024" target="_blank" class="tw-ml-auto tw-underline tw-text-primary-400">full blog post</a> to stay up to date with the most current news.`,
      date: 'Feb 29',
    },
    {
      title: 'Attn. Coinbase Prime Users: Important Notice Impacting ETH / ETH2 Balances',
      content: `In the near future, Coinbase Prime will merge ETH2 with staked Ethereum (ETH).
        <br>
        <br>
        This retroactive update will impact gain-loss reports and inventory views for those tracking ETH and ETH2 as separate assets in Bitwave.
        <br>
        <br>
        Once these changes are live, Bitwave customers may need to review their balances for staked ETH and ETH2 transactions.
        <br>
        <br>
        We're here to help you navigate this change, if you have any questions.
        <br>
        <br>
        Please see our <a href="https://www.bitwave.io/blog/important-update-eth-staking-for-coinbase-prime-users" target="_blank" class="tw-ml-auto tw-underline tw-text-primary-400">full statement</a> for details on how this may impact you.`,
      date: 'Feb 22',
    },
    {
      title: 'Bitwave 2024 Q1 Product Release Notes',
      content:
        'Bitwave’s 2024 Q1 product release focused on ensuring FASB readiness, enterprise grade staking, and making user’s workflows faster and more efficient. Read the full product release notes on our blog.',
      link: 'https://www.bitwave.io/blog',
      date: 'Jan 31',
    },
    {
      title:
        'FEATURE UPDATE: Gain Loss Scenario Runner to be Retired Feb 15. Upgrade to Gain Loss Via Inventory Views!',
      content:
        'Its officially 12+ months since we launched our new gain loss capability! The current gain loss scenario runner will be retired and unavailable Effective April 30th 2024 in favor of the new enhanced "inventory view" gain loss capability. Please reach out to our support team via In App Chat for assistance setting up your gain loss information using the inventory view feature.',
      date: 'Jan 31',
    },
    {
      title: 'New SERVICE: Get Help without EVER leaving the Bitwave App!',
      content: `We've released our new in app chat and ticketing system so that our customers never have to leave the app to get help. Simply click on the chat button in the bottom right our bitwave experts are ready to assist you.`,
      date: 'Jan 15',
    },
    {
      title: `New FEATURE: JE's on the Inventory View Actions Report`,
      content: `Actions report now contains, Contact, Category, Department, Class and Location.  You can now see your categorizations on the Actions Report (in addition to the Journal Entry Reports).`,
      date: 'Jan 15',
    },
    {
      title: 'New FEATURE: New Invoice Match UI',
      content:
        'We launched a new invoice match UI which can be found under AR/AP -> Invoice Match. This UI allows easy application of transaction data to Customer Invoices and Vendor Bills. Reach out to us via the chat button below for any questions...',
      date: 'Jan 15',
    },
    {
      title: 'New FEATURE: Import and load any file type into Bitwave',
      content:
        'With Bitwave Transforms we can automatically import data from any data source that has a repeatable file format. Reach out to us via the chat button below for any questions...',
      date: 'Jan 15',
    },
  ];

  mounted() {
    setTimeout(() => (this.showAnnouncements = true), 500);
  }

  get announcementsOnCurrentPage() {
    return this.announcements.slice((this.page - 1) * this.pageSize, this.page * this.pageSize);
  }

  getIcon(index: number) {
    return index === this.expandedAnnouncement ? 'fa-angle-up' : 'fa-angle-down';
  }

  showContent(index: number) {
    if (index === this.expandedAnnouncement) this.expandedAnnouncement = -1;
    else this.expandedAnnouncement = index;
  }
}
